var $ = require('jquery');
var jQuery = $
window.$ = $
window.jQuery = $
var jquery = $;

/*
export function initTCL (param) {
  console.log("init TCL")
  return param
}
*/
import TCLClient from './orFlowWuia'
var TCL = new TCLClient();

var cfm_lib_mng_config = {
    libraryId: 1,
    someOtherOption: 'ttt'
};



var getApiMethodAddress = function (methodname) {
    return ('http://localhost:8083/API/').toString() + methodname.toString() + '?dif=' + (new Date().getTime()).toString();
};


var callApi = function (method, data) {
    return $.ajax
        ({
            type: "POST",
            url: getApiMethodAddress(method),
            dataType: 'json',
            async: true,
            data: JSON.stringify(data),
            contentType: 'application/json',
            xhrFields: {
                withCredentials: true
            }
        }).then(function (data, status, jqxhr) {
            TCL.log('ajax returned: ' + JSON.stringify(data));
            if (data._c && data._c == 'APIError') {
                TCL.log('rejecting');
                return $.Deferred().reject(data).promise();
            }
            else {
                TCL.log('resolving');
                return $.Deferred().resolve(data).promise(); // if you want to return multiple arguments, you'd use
                // $.Deferred().resolve(data, status, jqxhr);
            }
        });
};



var cadfmApi = {};

cadfmApi.createSymbol = function (symbolName, categoryPath) {
    return callApi('Library/CreateSymbol', { category: categoryPath, libId: cfm_lib_mng_config.libraryId, name: symbolName })
        .then(function (data) {
            return $.Deferred().resolve({ id: data.SYMBOLID, name: symbolName }).promise();
        });
};

cadfmApi.checkOutSymbol = function (symbolId, reason) {
    return callApi('Library/CheckOut', { symbolRevisionId: symbolId, reason: reason })
        .then(function (data) {
            return $.Deferred().resolve({ id: data.SYMBOLID }).promise();
        });
};

cadfmApi.withdrawSymbol = function (symbolId) {
    return callApi('Library/Withdraw', { symbolRevisionId: symbolId })
        .then(function (data) {
            return $.Deferred().resolve({ id: data.SYMBOLID }).promise();
        });
};

cadfmApi.checkInSymbol = function (symbolId) {
    return callApi('Library/CheckIn', { symbolRevisionId: symbolId })

};

cadfmApi.getSymbolDetails = function (symbolId) {
    TCL.log('Getting symbol details');
    return callApi('Library/GetSymbolDetails', { ID: symbolId });
};


cadfmApi.getSymbolParams = function (symbolId) {
    return callApi('Library/GetParameters', { id: symbolId });
};

// paramArray = [{name:'xxx',value:'123'},{name:'yyy',value:'Homogeneous'},... ]
cadfmApi.setSymbolParams = function (symbolId, paramArray) {
    return callApi('Library/SetSymbolParams', { id: symbolId, parameters: paramArray });
};

cadfmApi.getSymbolModificationReason = function (symbolId) {
    return callApi('Library/GetReason', { id: symbolId });
};

cadfmApi.setSymbolModificationReason = function (symbolId, reason) {
    return callApi('Library/SaveReason', { symbolRevisionId: symbolId, text: reason });
};

cadfmApi.getSymbols = function (libId) {
    TCL.log('making params ');
    var params = {
        draw: 1,
        start: 0,
        length: 1000000,
        libid: libId,
        order: [
            {
                dir: 'asc',
                column: 3
            }
        ],
        columns: [
            { search: { value: '' } },
            { search: { value: '' } },
            { search: { value: '' } },
            { search: { value: '' } },
            { search: { value: '' } },
            { search: { value: '' } }
        ],
        search: { value: '' }
    };
    TCL.log('params: ' + JSON.stringify(params));
    return callApi('Library/GetSymbolsList', params);
};

cadfmApi.placePartGetDetails = function (edbid) {
    return callApi('CIS_Conf/placePartGetDetails', { edbid: edbid });
};

export default function () {


    var _tclApiThis = this;
    var _nextId = 0;
    var _avaitingCallbacks = {};
    var getNextId = function () {
        return ++_nextId;
    };
    this.initTCL = async function (args) {
        await TCL.properInitialization();

    }

    this.broadcast = function (commandWithArgs) {
        TCL.eval('evaluate', commandWithArgs);
    };
    this.defer = function (commandWithArgs) {
        TCL.log('deferring: ' + commandWithArgs)
        var curId = getNextId()
        commandWithArgs += ' ' + curId;
        TCL.log('whole cmd: ' + commandWithArgs)
        var d = $.Deferred();
        _avaitingCallbacks[curId] = d;
        TCL.eval('evaluate', commandWithArgs);
        return d.promise();
    };
    this.callback = function (callbackId, data) {
        TCL.log('callback id: ' + callbackId);
        TCL.log('callback data: ' + JSON.stringify(data));
        if (_avaitingCallbacks[callbackId]) {
            var d = _avaitingCallbacks[callbackId];
            delete _avaitingCallbacks[callbackId];
            TCL.log('found callback for id: ' + callbackId);
            if (data) {
                TCL.log('completing with data');
                if (data.status && data.status == 'OK') {
                    TCL.log('resolving with data');
                    d.resolve(data.data);
                } else {
                    TCL.log('rejecting with data');
                    d.reject(data.data);
                }
            } else {
                TCL.log('resolving with no data');
                d.resolve({});
            }

        }
    };

    this.getSymbolState = function (symbolDetails) {
        if (symbolDetails.symRevId == symbolDetails.pendingRevisionId) {
            if (symbolDetails.revisionNumber > 0) {
                return 'pending';
            } else {
                return 'new';
            }
        } else if (symbolDetails.symRevId == symbolDetails.activeRevisionId) {
            if (symbolDetails.pendingRevisionId > 0) {
                return 'checked out';
            } else {
                return 'active';
            }
        } else {
            return 'obsolete';
        }
    };

    this.prepareSymbolDetails = function (command, symbolDetails) {
        /*  activeRevisionId:0
           catId:21
           catName:"fc_cyclone"
           catPath:"fc_cyclone"
           developedAt:"D:\CFMServerWorkspace\orcadlibdevel"
           exposedAt:"D:\CFMServerWorkspace\orcadlib"
           inFolder:false
           inclCat:true
           libId:1
           libOwner:"fmadmin"
           pendingRevisionId:86
           processId:17422
           reason:"New symbol requested"
           revisionNumber:1
           searchImg:true
           symId:80
           symName:"TESTSYM015"
           symRevId:86
           typeId:2
       */
        var s = symbolDetails;
        var params = [command, s.symName, s.libId, s.catPath, s.inFolder, s.inclCat, s.developedAt, s.exposedAt];
        for (var i in params) {
            params[i] = TCL.escapeTCL(params[i]);
        }
        params = params.join(' ');
        return params;
    };
    this.openLibrary = function (symbolDetails) {

        var cmd = _tclApiThis.prepareSymbolDetails('::orFlowLibMng::openSymbol', symbolDetails);
        return _tclApiThis.defer(cmd);
    };

    this.openLocalCopy = function (symbolDetails) {

        var cmd = _tclApiThis.prepareSymbolDetails('::orFlowLibMng::openLocalCopy', symbolDetails);
        return _tclApiThis.defer(cmd);
    };

    this.pullFromProd = function (symbolDetails) {
        var cmd = _tclApiThis.prepareSymbolDetails('::orFlowLibMng::pullFromProduction', symbolDetails);
        return _tclApiThis.defer(cmd);
    };

    this.pullFromDevel = function (symbolDetails) {

    };

    this.makeSymbolSVG = function (symbolName, type, categoryPath) {
        var cmd = '::orFlowOrLibUtilGui::startGetSymbolJson ' + TCL.escapeTCL(symbolName)+ ' ' + TCL.escapeTCL(type)+ ' ' + TCL.escapeTCL(categoryPath);
        return _tclApiThis.defer(cmd);
    };
    this.makeFootprintSVG = function (footprintName, type) {
        var cmd = '::orFlowOrLibUtilGui::startGetFootprintJson ' + TCL.escapeTCL(footprintName)+ ' ' + TCL.escapeTCL(type);
        return _tclApiThis.defer(cmd);
    };
    this.openLibraryFromOmnya = function (libraryDetails) {
        var cmd = '::orFlowOrLibUtilGui::startOpenLibraryFromOmnya ' + TCL.escapeTCL(libraryDetails.revisionId) + ' ' + TCL.escapeTCL(libraryDetails.type) + ' ' + TCL.escapeTCL(libraryDetails.name) + ' ' + TCL.escapeTCL(libraryDetails.category);
        return _tclApiThis.defer(cmd);

    };
    this.pushLibraryToOmnya = function (libraryDetails) {
        var cmd = '::orFlowOrLibUtilGui::startPushLibraryToOmnya ' + TCL.escapeTCL(libraryDetails.revisionId) + ' ' + TCL.escapeTCL(libraryDetails.type) + ' ' + TCL.escapeTCL(libraryDetails.name) + ' ' + TCL.escapeTCL(libraryDetails.category);
        return _tclApiThis.defer(cmd);
    };
    this.pushFilesToDevel = function (symbolDetails) {
        var cmd = _tclApiThis.prepareSymbolDetails('::orFlowLibMng::pushToDevelop', symbolDetails);
        return _tclApiThis.defer(cmd);
    };
    this.openInExplorer = function (categoryPath, libId) {
        var cmd = '::orFlowLibMng::showInExplorer ' + libId + ' ' + TCL.escapeTCL(categoryPath);
        return _tclApiThis.defer(cmd);
    };

    this.saveSvg = function (symbolDetails, svgString) {
        var cmd = _tclApiThis.prepareSymbolDetails('::orFlowLibMng::saveSvg', symbolDetails);
        cmd += ' ' + TCL.escapeTCL(svgString);
        return _tclApiThis.defer(cmd);
    };
    this.onPartSelected = function (branchType, objectType, edbid) {
        var cmd = '::orFlowPlacer::onSelectedPart ' + TCL.escapeTCL(branchType) + ' ' + TCL.escapeTCL(objectType) + ' ' + TCL.escapeTCL(edbid);
        return _tclApiThis.broadcast(cmd);
    };
    this.placePart = function (revId, symbol, device, properties) {
        TCL.log(properties)
        if (device == undefined || device == null || device == "" /*|| device == "A" || device == "1"*/) {
            device = "-";
        }
        if (properties === undefined || symbol === '' || symbol === undefined || symbol === null) {
            return $.Deferred().reject("Some properties required for placing the part are missing")
        } else {
            /*DO NOT RMOVE. IT WILL BE USED LATER WHEN WE WILL WANT TO MANAGE PROP DISPLAY TYPE EVEN WITHOUT CIS AVAILABLE*/
            properties.push({
                name: "FC_PM_Revision_ID",
                value: revId,
                visibility: "TransferredToDesign"/*one of [TransferredToDesign, ForceDisplayed, ForceHidden] currently supported TransferredToDesign only */
            });
        }
        var command = ['::orFlowPlacer::startPlaceDevicePromise ', revId.toString(), TCL.escapeTCL(symbol), TCL.escapeTCL(device)];
        var props = [];
        var canBePlaced = false;


        for (let i = 0; i < properties.length; i++) {
            let p = properties[i];
            if (["TransferredToDesign", "ForceDisplayed", "ForceHidden"].indexOf(p.visibility) >= 0) {
                let visibilityTranslated = '0';
                switch (p.visibility) {
                    case "TransferredToDesign":
                        visibilityTranslated = '2';
                        break;
                    case "ForceDisplayed":
                        visibilityTranslated = '1';
                        break;
                    case "ForceHidden":
                        visibilityTranslated = '0';
                        break;
                    default:
                        break;
                }
                props.push(
                    TCL.escapeTCL(p.name)
                    , TCL.escapeTCL(p.value)
                    , TCL.escapeTCL(visibilityTranslated)
                );
            }
        }

        props = props.join(' ');

        command = command.join(' ') + ' [list ' + props + ']';
        //alert(command)
        return _tclApiThis.defer(command);







    };
    this.concatOlb = function (sourceFolderPath, targetOlbFilePath) {
        var cmd = '::orFlowOrLibUtilGui::startConcatOlb ' + TCL.escapeTCL(sourceFolderPath) + ' ' + TCL.escapeTCL(targetOlbFilePath);
        return _tclApiThis.defer(cmd);
    };
    this.refreshSymbolInfo = function () {
        var cmd = '::orFlowPlacer::refreshSymbolInfo' ;
        return _tclApiThis.defer(cmd);
    };
    this.openProjectFromOmnya = function (dsnPath) {
        var cmd = '::lb::getDesign ' + TCL.escapeTCL(dsnPath) + '; #';
        return _tclApiThis.broadcast(cmd);

    };
    this.generateBomForOmnya = function (dsnPath, partNumberPropertyName) {
        var cmd = '::orFlowOrLibUtilGui::startGenerateBom ' + TCL.escapeTCL(dsnPath) + ' ' + TCL.escapeTCL(partNumberPropertyName);
        return _tclApiThis.defer(cmd);
    };
}




// WEBPACK FOOTER //
// ./src/Tools/tclAPI.js